/*@ngInject*/
module.exports = function($rootScope, $uibModal, publicServicesService, publicUsersService, clipboard) {
	return {
		scope: {
			serviceId: '@'
		},
		bindToController: true,
		controllerAs: 'vm',
		controller: function() {
			let vm = this;
			vm.commentError = !$rootScope.currentUser;
			vm.userNotLoggedIn = !$rootScope.currentUser;
			vm.copyToClipboardSupported = true;
			vm.addCommentMessage = !$rootScope.currentUser ? 'Kommentaari lisamiseks ' : '';
			vm.showSuggestionModal = false;
			vm.showSuggestionAddedMessage = false;
			vm.showSuggestionErrorMessage = false;
			vm.addingSuggestionsAllowed = false;
			vm.imageModalOpen = false;

			vm.$onInit = function(){
				vm.copyToClipboardSupported = clipboard.supported;

				publicServicesService.getServiceDataById(vm.serviceId).then((response) => {
					vm.serviceData = response.data;

					vm.commentsAllowed = response.data.comments_allowed;
					vm.addingSuggestionsAllowed = response.data.suggestions_allowed;
					vm.serviceData.serviceType = publicServicesService.TYPE_OBJECT;
					vm.getServiceFileNames(vm.serviceData.image_files);
					vm.getComponentImageNames(vm.serviceData.components);
				});
			};

			vm.openSuggestionModal = () => {
				vm.showSuggestionAddedMessage = false;
				vm.showSuggestionErrorMessage = false;
				vm.showSuggestionModal = true;
			};

			vm.getServiceFileNames = (imageFiles) => {
				angular.forEach(imageFiles, (imageFile) => {
					imageFile.fileName = imageFile.name;
				});
			};

			vm.getComponentImageNames = (components) => {
				angular.forEach(components, (component) => {
					component.image_file.fileName = component.image_file ? _.find(component.image_file.name, {language: 'est'}).value : '';
				});
			};

			vm.openImage = () => {
				$('.slick-current').find('a')[0].click();
			};

			vm.addComment = () => {
				publicServicesService.addComment(vm.serviceData).then((res) => {
					if(res.data === 'ok'){
						vm.commentError = false;
						vm.addCommentMessage = 'comment_notification';
						vm.serviceData.newComment = '';
					}
				});
			};

			vm.openImage = (imageFile) => {
				vm.imageId = imageFile.id;
				vm.imageName = imageFile.fileName;
				vm.imageReferenceId = vm.serviceData.id;
				vm.imageModalOpen = true;
			};
		},

		template: require('./service-details.html')
	};
};



/** WEBPACK FOOTER **
 ** ./app/shared/directives/services/view/service-details.directive.js
 **/